import { useCostomerInfo } from './hooks';
import { CustomerInfoTemplate } from 'views/components/templates/establishes/';
import { Gauge, GaugeSP, getGaugeValue } from 'views/components/atoms/gauge';
import { useLocation } from 'react-router-dom';

export const CustomerInfo = () => {
  const tempProps = useCostomerInfo();
  const location = useLocation();

  return (
    <form className="establishFormSP" onSubmit={tempProps.formik.handleSubmit}>
      <GaugeSP currentPage={getGaugeValue(location.pathname)} />
      <CustomerInfoTemplate {...tempProps} />
    </form>
  );
};
